import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import { FaHome } from 'react-icons/fa'; // Import the home icon
import '../App.css';

const DonationSuccess = () => {
  const location = useLocation();
  const message = location.state?.message || 'Donation successful!';
  const navigate = useNavigate(); // Get navigate to redirect

  const navigateHome = () => {
    navigate('/dashboard'); // Replace with your dashboard route
  };

  return (
    <div className="donation-success-container">
      <div className="donation-success-message">
        {message}
      </div>
      <p className="donation-success-subtext">
        May your Donation's be accepted and rewarded abundantly.
      </p>

      <button className="go-home-btn" onClick={navigateHome}>
        <FaHome size={24} style={{ marginRight: '8px' }} /> 
      </button>
    </div>
  );
};

export default DonationSuccess;
